@if (message) {
  <div [ngClass]="getMessageContainer()">
    <app-header
      [message]="currentMessage"
      [heading]="originalMessage?.heading ?? null"
      [numberOfVersions]="numberOfVersions"
      [laterMessageExists]="laterMessageExists"
      [showApp]="showApp"
      [isNewMessage]="isNewMessage"
      (changeVersion)="changeVersion($event)"
      (saveChanges)="saveChanges($event)"
      (closeMessage)="closeMessage($event)"
      (changeMessageType)="onChangeMessageType($event)"
      >
    </app-header>
    <div class="message-body">
      @if (messageType == 'TI') {
        <app-app-message-form
          [numberOfVersions]="numberOfVersions"
          [message]="currentMessage!"
          />
      }
      @if (messageType == 'TOT') {
        <app-web-message-form
          [numberOfVersions]="numberOfVersions"
          [message]="currentMessage!"
          />
      }
    </div>
  </div>
}
@if (!message) {
  <div class="text-container">
    <div class="centered-text">Inget meddelande valt</div>
  </div>
}
